<script setup>
const props = defineProps({
  customClass: String,
  icon: Boolean,
  iconPosition: String,
  text: String,
  ariaLabel: String,
  url: String,
  target: String,
  color: String,
  type: String, // a, button, span
  size: String, // sm, none, lg
});

const colorClass = ref(props.color ? "btn--" + props.color : "");
const sizeClass = ref(props.size ? "btn--" + props.size : "");
const iconClass = ref(
  props.icon
    ? props.iconPosition === "left"
      ? "btn--icon-l"
      : "btn--icon-r"
    : ""
);
</script>

<template>
  <a
    v-if="type === 'link'"
    :href="url"
    :target="target ? target : '_blank'"
    class="btn group"
    :class="[colorClass, sizeClass, iconClass, customClass]"
    :aria-label="ariaLabel ? ariaLabel : ''"
  >
    <span v-if="icon && iconPosition === 'left'" class="btn__icon">
      <IconChevronRight />
    </span>
    <span class="-mt-px">
      {{ text }}
    </span>
    <span v-if="icon && iconPosition === 'right'" class="btn__icon">
      <IconChevronRight />
    </span>
  </a>
  <button
    v-else-if="type === 'button'"
    class="btn group"
    :class="[colorClass, sizeClass, iconClass, customClass]"
    :aria-label="ariaLabel ? ariaLabel : ''"
  >
    <span v-if="icon && iconPosition === 'left'" class="btn__icon">
      <IconChevronRight />
    </span>
    <span class="-mt-px">
      {{ text }}
    </span>
    <span v-if="icon && iconPosition === 'right'" class="btn__icon">
      <IconChevronRight />
    </span>
  </button>
  <span
    v-else-if="type === 'span'"
    class="btn group"
    :class="[colorClass, sizeClass, iconClass, customClass]"
  >
    <span v-if="icon && iconPosition === 'left'" class="btn__icon">
      <IconChevronRight />
    </span>
    <span class="-mt-px">
      {{ text }}
    </span>
    <span v-if="icon && iconPosition === 'right'" class="btn__icon">
      <IconChevronRight />
    </span>
  </span>
</template>
